var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram reels"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8 2.5L10.4411 4.94107C10.4736 4.97362 10.5264 4.97362 10.5589 4.94107L13 2.5M7.16667 13.3333L9.34514 10.9993C9.37093 10.9716 9.41209 10.9648 9.44541 10.9827L11.5479 12.109C11.5842 12.1285 11.6294 12.1184 11.654 12.0854L13.8333 9.16667M5.66667 5H15.3333C16.2668 5 16.7335 5 17.09 5.18166C17.4036 5.34144 17.6586 5.59641 17.8183 5.91002C18 6.26654 18 6.73325 18 7.66667V14.8333C18 15.7668 18 16.2335 17.8183 16.59C17.6586 16.9036 17.4036 17.1586 17.09 17.3183C16.7335 17.5 16.2668 17.5 15.3333 17.5H5.66667C4.73325 17.5 4.26654 17.5 3.91002 17.3183C3.59641 17.1586 3.34144 16.9036 3.18166 16.59C3 16.2335 3 15.7668 3 14.8333V7.66667C3 6.73325 3 6.26654 3.18166 5.91002C3.34144 5.59641 3.59641 5.34144 3.91002 5.18166C4.26654 5 4.73325 5 5.66667 5Z",
    stroke: "#009FDF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoViews);
export default __webpack_public_path__ + "static/media/video_views.1de9869654b5f26bdbac81f8c11e22ce.svg";
export { ForwardRef as ReactComponent };